import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@material-ui/core'
import { SaveButton } from 'components/Common/Button/SaveButton'
import { useRef, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { PartyItem } from '../PartiesPages'
import { FormParties } from './FormParties'

type PartiesModalProps = {
  onConfirm: (party: PartyItem) => Promise<PartyItem | boolean>
  onCancel?: () => void
  open?: boolean
  onClose?: () => void
  data: PartyItem
}

export const PartiesModal = ({
  onConfirm,
  onCancel,
  open,
  onClose,
  data: defaultValues,
}: PartiesModalProps) => {
  const { t } = useTranslation()
  const formRef = useRef(null)
  const [loading, setLoading] = useState(false)

  const handleConfirm = async (data) => {
    setLoading(true)
    try {
      await onConfirm(data)
      onClose()
    } catch (err) {
      // eslint-disable-next-line
      console.log(err)
    }
    setLoading(false)
  }

  const handleCancel = () => {
    onCancel && onCancel()
    onClose()
  }

  const { control, resetField, handleSubmit, watch } = useForm<PartyItem>({
    defaultValues,
  })

  return (
    <form onSubmit={handleSubmit(handleConfirm)} ref={formRef}>
      <Dialog open={open} maxWidth="md" onClose={handleCancel}>
        <DialogTitle>
          {defaultValues.id
            ? t('system:edit-party', 'Edit Party')
            : t('system:new-party', 'New Party')}
        </DialogTitle>

        <DialogContent>
          <FormParties
            defaultValues={defaultValues}
            control={control}
            resetField={resetField}
            watch={watch}
          />
        </DialogContent>

        <DialogActions>
          <Button onClick={handleCancel} color="secondary">
            {t('common:cancel', 'Cancel')}
          </Button>
          <SaveButton
            saving={loading}
            onClick={handleSubmit(handleConfirm)}
            color="primary"
          >
            {t('common:save', 'Save')}
          </SaveButton>
        </DialogActions>
      </Dialog>
    </form>
  )
}
